module.exports = __webpack_public_path__ + "static/media/add_border.7348c75f.svg";